import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-receipt-search-sub-header',
  templateUrl: './receipt-search-sub-header.component.html',
  styleUrls: ['./receipt-search-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptSearchSubHeaderComponent extends SupportComponent {
  /** ページタイトル */
  pageTitle?: string;

  constructor(commonService: CommonLibService) {
    super(commonService);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}
}
